import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BffUserService } from '@canvas/four-r-digital';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BottomNavComponent } from './modules/shared/components/bottom-nav/bottom-nav.component';
import { InstallButtonComponent } from './modules/shared/components/install-button/install-button.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'finance-pwa-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NgxSpinnerModule,
    BottomNavComponent,
    InstallButtonComponent,
  ],
})
export class AppComponent {
  loggedIn = false;

  constructor(private readonly bffService: BffUserService) {
    document.title = environment.appName;

    if (environment.useFakeLogin) {
      this.loggedIn = true;
      return;
    }

    this.bffService.isAuthenticated().subscribe({
      next: (res) => (this.loggedIn = res),
    });
  }
}
